import { connect } from 'react-redux'
import { Viewport } from './Viewport.jsx'
import { isPrintPreviewOpened } from 'redux/print/selectors'
import { isMinimapDisplayed } from 'redux/minimap/selectors'
import { isCurrentMediaSourceLoaded } from 'redux/currentMedia/selectors'

const mapStateToProps = (state, ownProps) => ({
    isPrintPreviewOpened: isPrintPreviewOpened(state),
    isMinimapDisplayed: isMinimapDisplayed(state),
    isSourceLoaded: (id) => isCurrentMediaSourceLoaded(state, id),
})

export const ViewportContainer = connect(
    mapStateToProps,
)(Viewport)
